import { render, staticRenderFns } from "./ErrorUnauthorized.vue?vue&type=template&id=5186ae0a&"
import script from "./ErrorUnauthorized.vue?vue&type=script&lang=js&"
export * from "./ErrorUnauthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5186ae0a')) {
      api.createRecord('5186ae0a', component.options)
    } else {
      api.reload('5186ae0a', component.options)
    }
    module.hot.accept("./ErrorUnauthorized.vue?vue&type=template&id=5186ae0a&", function () {
      api.rerender('5186ae0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Player/ErrorUnauthorized.vue"
export default component.exports